import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from 'uikit/inputs';

const FormFieldText = ({ fieldId, value = '', schema = {}, updateField }) => (
  <TextInput
    autoComplete={schema.autoComplete}
    autoCorrect={schema.autoCorrect}
    spellCheck={schema.spellCheck}
    placeholder={schema.placeholder}
    onKeyDown={schema.onKeyDown}
    inputTestId={schema.testId}
    id={fieldId}
    value={value === null ? '' : value}
    onChange={(inputValue) => updateField(inputValue)}
    isDisabled={schema.isDisabled}
    maxLength={schema.maxLength}
  />
);

FormFieldText.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  schema: PropTypes.shape({
    autoComplete: PropTypes.string,
    autoCorrect: PropTypes.string,
    spellCheck: PropTypes.string,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    isFullWidth: PropTypes.bool,
    isDisabled: PropTypes.bool,
    testId: PropTypes.string,
    maxLength: PropTypes.number,
  }),
  updateField: PropTypes.func.isRequired,
};

export default FormFieldText;
